import clsx from "clsx";
import { BackIcon } from "@/components/RFIcon";
interface WrapperProps {
	placeholder?: string;
	text?: string;
	style?: React.CSSProperties;
	labelLeft?: string;
	onClick?: () => void;
	textClassName?: string;
	disabled?: boolean;
}

export function Holder({
	text,
	style,
	labelLeft,
	onClick,
	placeholder = "请选择",
	textClassName,
	disabled,
}: WrapperProps) {
	return (
		<div
			className={clsx(
				"flex h-12 items-center rounded-full p-3 pl-5 font-bold",
				disabled ? "rf-select-normal" : "rf-select-normal__active",
			)}
			style={{ ...style }}
			onClick={() => onClick && onClick()}
		>
			<div className="mr-4 flex flex-1 items-center">
				{labelLeft && <label>{labelLeft}</label>}
				{text ? <span>{text}</span> : <span className="c3_85_text">{placeholder}</span>}
			</div>

			{disabled ? null : <BackIcon strokeWidth={1.5} className="text-c3c3c3 dark:text-858585/80 -rotate-90" />}
		</div>
	);
}
